import { render, staticRenderFns } from "./LatestAlarms.vue?vue&type=template&id=445507f4&scoped=true&"
import script from "./LatestAlarms.vue?vue&type=script&lang=js&"
export * from "./LatestAlarms.vue?vue&type=script&lang=js&"
import style0 from "./LatestAlarms.vue?vue&type=style&index=0&id=445507f4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445507f4",
  null
  
)

export default component.exports